<template>
  <div class="w-full h-full font-bold">
    <div class="flex w-screen h-full">
      <side-nav />
    </div>
    <logout-modal v-if="showLogoutDialog" />
    <notification-drawer
      v-if="showNotificationDrawer"
      :showDrawer="showNotificationDrawer"
      @closeDrawer="closeShowNotificationDrawer"
    />
    <base-footer />
  </div>
</template>

<script>
import refreshToken from '@/mixins/refreshToken.js'
import notification from '@/mixins/notification.js'

// utils
import { ROUTES_TO_EXCLUDE_FROM_SESSION_EXPIRY } from '@/utils/constants'

export default {
  mixins: [refreshToken, notification],
  name: 'Main',
  components: {
    NotificationDrawer: () => import('@/components/v2/base/NotificationDrawer'),
    SideNav: () => import('@/components/v2/base/SideNav.vue'),
    BaseFooter: () => import('@/components/v2/base/BaseFooter.vue'),
    LogoutModal: () => import('@/components/v2/app/LogoutModal.vue')
  },
  data () {
    return {
      showLogoutDialog: true,
      isLoading: false
    }
  },
  computed: {
    isOnDevEnvironment () {
      return process.env.NODE_ENV !== 'production'
    },
    showSessionExpiryModal () {
      return !ROUTES_TO_EXCLUDE_FROM_SESSION_EXPIRY.includes(this.$route.name)
    }
  },
  async mounted () {
    await this.refreshTokenTimeout()
    if (this.isOnDevEnvironment) {
      await this.getAllNotifications()
    }
  }
}
</script>
